module.exports = __webpack_public_path__ + "img/bg-left.9acae9f0.png";